import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

const VARSAYILAN_ADIMLAR = [
  'Fatura Hazırlandı',
  'İhracat Gümrük İşlemleri Yapılıyor',
  'İthalat Gümrük İşlemleri Yapılıyor',
  'Gümrük Tamamlandı'
];

function Gumruk() {
  const [seferler, setSeferler] = useState([]);
  const [seciliSeferId, setSeciliSeferId] = useState(null);
  const [adimlar, setAdimlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);

  const seciliSefer = seferler.find(s => s.id === seciliSeferId);

  useEffect(() => {
    seferleriGetir();
  }, []);

  useEffect(() => {
    if (seciliSeferId) {
      adimlariGetir(seciliSeferId);
    }
  }, [seciliSeferId]);

  const seferleriGetir = async () => {
    setYukleniyor(true);
    const { data } = await supabase
      .from('seferler')
      .select('*')
      .not('durum', 'eq', 'Teslim Edildi')
      .order('created_at', { ascending: false });
    if (data && data.length > 0) {
      setSeferler(data);
      setSeciliSeferId(data[0].id);
    }
    setYukleniyor(false);
  };

  const adimlariGetir = async (seferId) => {
    const { data } = await supabase
      .from('gumruk_adimlar')
      .select('*')
      .eq('sefer_id', seferId)
      .order('sira');

    if (data && data.length === 0) {
      const yeniAdimlar = VARSAYILAN_ADIMLAR.map((ad, i) => ({
        sefer_id: seferId,
        ad,
        sira: i + 1,
        tamamlandi: false
      }));
      const { data: eklenenler } = await supabase
        .from('gumruk_adimlar')
        .insert(yeniAdimlar)
        .select()
        .order('sira');
      setAdimlar(eklenenler || []);
    } else {
      setAdimlar(data || []);
    }
  };

  const adimTamamla = async (adim) => {
    const yeniDeger = !adim.tamamlandi;

    await supabase
      .from('gumruk_adimlar')
      .update({
        tamamlandi: yeniDeger,
        tamamlanma_tarihi: yeniDeger ? new Date().toISOString().split('T')[0] : null
      })
      .eq('id', adim.id);

    // Taze veri çek
    const { data } = await supabase
      .from('gumruk_adimlar')
      .select('*')
      .eq('sefer_id', seciliSeferId)
      .order('sira');

    setAdimlar(data || []);
  };

  const tamamlananSayisi = adimlar.filter(a => a.tamamlandi).length;
  const toplamAdim = adimlar.length;
  const yuzde = toplamAdim > 0 ? Math.round((tamamlananSayisi / toplamAdim) * 100) : 0;

  return (
    <div style={{ flex: 1, background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>

      <div style={{ background: '#fff', padding: '14px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '18px', fontWeight: '600' }}>Gümrük Takibi</div>
      </div>

      {yukleniyor ? (
        <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Yükleniyor...</div>
      ) : seferler.length === 0 ? (
        <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Aktif sefer yok. TIR/Sefer sayfasından sefer ekleyin.</div>
      ) : (
        <div style={{ padding: '24px', display: 'grid', gridTemplateColumns: '280px 1fr', gap: '20px' }}>

          {/* Sol: Sefer Listesi */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: '600', color: '#888', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Aktif Seferler</div>
            {seferler.map((s) => (
              <div
                key={s.id}
                onClick={() => setSeciliSeferId(s.id)}
                style={{
                  background: seciliSeferId === s.id ? '#0D3B7A' : '#fff',
                  color: seciliSeferId === s.id ? '#fff' : '#1a1a1a',
                  borderRadius: '10px',
                  padding: '14px 16px',
                  marginBottom: '10px',
                  cursor: 'pointer',
                  border: '1px solid #eee',
                }}>
                <div style={{ fontWeight: '700', fontSize: '14px', marginBottom: '4px' }}>{s.sefer_no}</div>
                <div style={{ fontSize: '12px', opacity: 0.7, marginBottom: '6px' }}>{s.guzergah}</div>
                <span style={{
                  background: seciliSeferId === s.id ? 'rgba(255,255,255,0.2)' : '#FEF3C7',
                  color: seciliSeferId === s.id ? '#fff' : '#854F0B',
                  padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600'
                }}>{s.durum}</span>
              </div>
            ))}
          </div>

          {/* Sağ: Gümrük Adımları */}
          {seciliSefer && (
            <div>
              <div style={{ background: '#0D3B7A', borderRadius: '10px', padding: '18px 20px', marginBottom: '16px', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                {[
                  { label: 'Sefer No', value: seciliSefer.sefer_no },
                  { label: 'Güzergah', value: seciliSefer.guzergah },
                  { label: 'Sürücü', value: seciliSefer.surucu_ad },
                ].map((item, i) => (
                  <div key={i}>
                    <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.5)', marginBottom: '4px', textTransform: 'uppercase' }}>{item.label}</div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>{item.value}</div>
                  </div>
                ))}
              </div>

              <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #eee', overflow: 'hidden' }}>
                <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Gümrük Süreç Adımları</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>{tamamlananSayisi} / {toplamAdim} tamamlandı</div>
                </div>

                {/* İlerleme Barı */}
                <div style={{ padding: '12px 20px 0', background: '#f9f9f9' }}>
                  <div style={{ background: '#eee', borderRadius: '10px', height: '8px', overflow: 'hidden' }}>
                    <div style={{
                      background: yuzde === 100 ? '#3B6D11' : '#0D3B7A',
                      height: '100%',
                      width: `${yuzde}%`,
                      borderRadius: '10px',
                      transition: 'width 0.3s'
                    }} />
                  </div>
                  <div style={{ fontSize: '11px', color: '#888', marginTop: '4px', marginBottom: '12px' }}>
                    %{yuzde} tamamlandı
                  </div>
                </div>

                <div style={{ padding: '12px 20px 16px' }}>
                  {adimlar.map((adim) => (
                    <div key={adim.id} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                      padding: '10px 14px',
                      borderRadius: '8px',
                      marginBottom: '6px',
                      background: adim.tamamlandi ? '#EAF3DE' : '#f9f9f9',
                      border: adim.tamamlandi ? '1px solid #c6e6a3' : '1px solid #eee',
                    }}>
                      <div style={{
                        width: '26px', height: '26px', borderRadius: '50%',
                        background: adim.tamamlandi ? '#639922' : '#ddd',
                        color: '#fff', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', fontSize: '12px', fontWeight: '700', flexShrink: 0
                      }}>
                        {adim.tamamlandi ? '✓' : adim.sira}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', fontWeight: '500', color: adim.tamamlandi ? '#3B6D11' : '#1a1a1a' }}>
                          {adim.ad}
                        </div>
                        {adim.tamamlanma_tarihi && (
                          <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>
                            {new Date(adim.tamamlanma_tarihi).toLocaleDateString('tr-TR')}
                          </div>
                        )}
                      </div>
                      <button
                        onClick={() => adimTamamla(adim)}
                        style={{
                          background: adim.tamamlandi ? '#fff' : '#0D3B7A',
                          color: adim.tamamlandi ? '#888' : '#fff',
                          border: adim.tamamlandi ? '1px solid #ddd' : 'none',
                          padding: '5px 14px', borderRadius: '6px',
                          fontSize: '11px', cursor: 'pointer', fontWeight: '600'
                        }}>
                        {adim.tamamlandi ? 'Geri Al' : 'Tamamla'}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Gumruk;